var _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHomeIntroSectionBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2603,
    height: 1626,
    viewBox: "0 0 2603 1626",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 596,
    cy: 646.5,
    rx: 596,
    ry: 646.5,
    fill: "#EBF8FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1355.5,
    cy: 715,
    rx: 607.5,
    ry: 659,
    fill: "#F2FBFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1995.5,
    cy: 967,
    rx: 607.5,
    ry: 659,
    fill: "#EBF8FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHomeIntroSectionBackground);
export default ForwardRef;